import { TOTAL_YEARLY_CONTRIBUTION } from "./consts";

export interface IfIsaAllowanceBreakdownArgs {
  /** The API's figure, already net of pending moves in when those are on. */
  availableToInvest?: number;
  totalContribution: number;
  pendingMovesIn?: number;
  /** The API's confirmed use; preferred over working it back from what is left. */
  allowanceUsed?: number;
}

export interface IfIsaAllowanceBreakdown {
  used: number;
  /** Held by moves into the IF-ISA that have not happened yet. */
  pending: number;
  remaining: number;
  usedPercentage: number;
}

/** Used, held by pending moves and remaining, which together make up the annual allowance. */
export const ifIsaAllowanceBreakdown = ({
  availableToInvest,
  totalContribution,
  pendingMovesIn,
  allowanceUsed,
}: IfIsaAllowanceBreakdownArgs): IfIsaAllowanceBreakdown => {
  const remaining =
    typeof availableToInvest === "number"
      ? Math.max(0, Math.floor(availableToInvest))
      : Math.max(0, TOTAL_YEARLY_CONTRIBUTION - totalContribution);
  const pending = pendingMovesIn ?? 0;
  const used =
    allowanceUsed ??
    Math.max(0, TOTAL_YEARLY_CONTRIBUTION - remaining - pending);
  const usedPercentage =
    used > 0 ? Math.min((used / TOTAL_YEARLY_CONTRIBUTION) * 100, 100) : 0;
  return { used, pending, remaining, usedPercentage };
};
